import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowRight, X } from 'lucide-react'
import { Button } from '../ui/button'
import { Card, CardContent } from '../ui/card'
import ResumenRecorrido from './ResumenRecorrido'

const PantallaTerminado = ({ recorrido, sesionId, onCerrar }) => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-muted/50 flex flex-col items-center justify-center px-4 py-8">
      <div className="w-full max-w-lg space-y-4">
        <div className="text-center space-y-2">
          <div className="text-5xl">✅</div>
          <h1 className="text-2xl font-bold text-foreground">Entrenamiento completado</h1>
          {recorrido?.programa_titulo && (
            <p className="text-sm text-muted-foreground">{recorrido.programa_titulo}</p>
          )}
        </div>

        <Card>
          <CardContent className="py-4">
            <ResumenRecorrido recorrido={recorrido} />
          </CardContent>
        </Card>

        <div className="flex flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            className="flex-1"
            onClick={onCerrar || (() => navigate(-1))}
          >
            <X className="h-4 w-4 mr-1" />
            Cerrar
          </Button>
          {sesionId && (
            <Button
              className="flex-1"
              onClick={() => navigate(-1)}
            >
              Volver
              <ArrowRight className="h-4 w-4 ml-1" />
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default PantallaTerminado
